import {
  getCourseGroupsByProgramUrl,
  getProgramByIdUrl,
  getProgramsUrl,
  getProgramsUrlWithParam,
} from "../config/Config";
import {
  deleteRequest,
  getRequest,
  postRequest,
  putRequest,
} from "./ServiceHelper";

export class ProgramService {
  static createProgram = (program) => {
    return postRequest(getProgramsUrl(), program);
  };

  static getPrograms = () => {
    return getRequest(getProgramsUrl());
  };

  static getProgramsByAcSub = (acSub) => {
    return getRequest(getProgramsUrlWithParam(acSub));
  };

  static getCourseGroupsByProgram = (programId) => {
    return getRequest(getCourseGroupsByProgramUrl(programId));
  };

  static deleteProgram = (programId) => {
    return deleteRequest(getProgramByIdUrl(programId));
  };

  static editProgram = (program) => {
    return putRequest(getProgramByIdUrl(program.id), program);
  };
}
